import type { IMeetingProcessedNotificationData } from "@frontend-shared/types";
import { CheckCircle2 } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IMeetingProcessedCardProps {
  uuid: string;
  data: IMeetingProcessedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewMeeting: (meetingUuid: string) => void;
}

const MeetingProcessedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewMeeting,
}: IMeetingProcessedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewMeeting = useCallback(
    () => onViewMeeting(data.meetingUuid),
    [onViewMeeting, data.meetingUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="meeting_processed"
      createdAt={createdAt}
      isRead={isRead}
      icon={<CheckCircle2 className="h-5 w-5 text-emerald-500" />}
      iconBgClassName="bg-emerald-500/10"
      ctaLabel={t("view_meeting")}
      onCtaClick={handleViewMeeting}
      body={t("type.meeting_processed.body", {
        meetingTitle: data.meetingTitle,
      })}
    />
  );
};

export const MeetingProcessedCard = memo(MeetingProcessedCardComponent);
